module.exports = "<p>\n  unify-marketing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing/unify-marketing.component.html
// module id = ./src/app/prospect/unify-marketing/unify-marketing.component.html
// module chunks = main